export const CUSTOM_SHADOW_MIN_BLUR = 0;
export const CUSTOM_SHADOW_MAX_BLUR = 100;
